module.exports = __webpack_public_path__ + "img/27.c7a4a47e.jpg";